export default __webpack_public_path__ + "static/media/clients_m.bb62b3f8.jpg";